import * as types from '../../constants/event/invitationEventConstants';
import { INVITATION_EVENT_INFO_REWARD_REQUEST } from '../../constants/event/invitationEventConstants';

export const invitationEventListRequest = ({
  page,
  pageLength,
  callback,
  error,
}) => ({
  type: types.INVITATION_EVENT_LIST_REQUEST,
  page,
  pageLength,
  callback,
  error,
});

export const invitationEventList = (list) => ({
  type: types.INVITATION_EVENT_LIST,
  list,
});

export const invitationEventResponse = (resultCode, message) => ({
  type: types.INVITATION_EVENT_RESPONSE_MESSAGE,
  resultCode,
  message,
});

export const invitationEventCreate = ({
  invNo,
  invitationLimit,
  regDuration,
  inviterXper,
  inviterPer,
  inviterItem1,
  inviterItem1Count,
  inviterItem2,
  inviterItem2Count,
  invitedXper,
  invitedPer,
  invitedItem1,
  invitedItem1Count,
  invitedItem2,
  invitedItem2Count,
  initialXper,
  walletNo,
  beginAt,
  endAt,
  createdAt,
  depositTransactionStatus,
  eventType,
  initialPer,
  rewardRatio,
  rewardLimit,
  tokenType,
  callback,
  error,
}) => ({
  type: types.INVITATION_EVENT_CREATE_REQUEST,
  invNo,
  invitationLimit,
  regDuration,
  inviterXper,
  inviterPer,
  inviterItem1,
  inviterItem1Count,
  inviterItem2,
  inviterItem2Count,
  invitedXper,
  invitedPer,
  invitedItem1,
  invitedItem1Count,
  invitedItem2,
  invitedItem2Count,
  initialXper,
  walletNo,
  beginAt,
  endAt,
  createdAt,
  depositTransactionStatus,
  eventType,
  initialPer,
  rewardRatio,
  rewardLimit,
  tokenType,
  callback,
  error,
});

export const invitationEventInfoDetailsRequest = ({
  invNo,
  callback,
  error,
}) => ({
  type: types.INVITATION_EVENT_INFO_DETAILS_REQUEST,
  invNo,
  callback,
  error,
});

export const invitationEventHistoryListRequest = ({
  page,
  pageLength,
  invNo,
  searchType,
  searchString,
  callback,
  error,
}) => ({
  type: types.INVITATION_EVENT_INFO_HISTORY_REQUEST,
  page,
  pageLength,
  invNo,
  searchType,
  searchString,
  callback,
  error,
});

export const invitationEventRewardListRequest = ({
  page,
  pageLength,
  invNo,
  searchType,
  searchString,
  callback,
  error,
}) => ({
  type: types.INVITATION_EVENT_INFO_REWARD_REQUEST,
  page,
  pageLength,
  invNo,
  searchType,
  searchString,
  callback,
  error,
});

export const invitationEventInfoDetails = (scheduleInfo, logInfo) => ({
  type: types.INVITATION_EVENT_INFO_DETAILS,
  scheduleInfo,
  logInfo,
});

export const invitationEventInfoUpdateRequest = ({
  invNo,
  invitationLimit,
  regDuration,
  inviterXper,
  inviterItem1,
  inviterItem1Count,
  inviterItem2,
  inviterItem2Count,
  invitedXper,
  invitedItem1,
  invitedItem1Count,
  invitedItem2,
  invitedItem2Count,
  initialXper,
  beginAt,
  endAt,
  initialPer,
  rewardLimit,
  rewardRatio,
  callback,
  error,
}) => ({
  type: types.INVITATION_EVENT_INFO_UPDATE_REQUEST,
  invNo,
  invitationLimit,
  regDuration,
  inviterXper,
  inviterItem1,
  inviterItem1Count,
  inviterItem2,
  inviterItem2Count,
  invitedXper,
  invitedItem1,
  invitedItem1Count,
  invitedItem2,
  invitedItem2Count,
  initialXper,
  beginAt,
  endAt,
  initialPer,
  rewardLimit,
  rewardRatio,
  callback,
  error,
});

export const invitationEventInfoDeleteRequest = ({ invNo, callback, error }) => ({
  type: types.INVITATION_EVENT_INFO_DELETE_REQUEST,
  invNo,
  callback,
  error
});

export const setTotalCount = (totalCount) => ({
  type: types.SET_TOTAL_COUNT,
  totalCount,
});

export const setInvitationEventListPagination = (page, totalCount) => ({
  type: types.SET_INVITATION_EVENT_PAGINATION,
  page,
  totalCount,
});

export const setInvitationEventHistoryPagination = (
  page,
  totalCount,
  searchType,
  searchString,
) => ({
  type: types.SET_INVITATION_EVENT_PAGINATION,
  page,
  totalCount,
  searchType,
  searchString,
});

export const invitationEventPageReset = () => ({
  type: types.INVITATION_EVENT_PAGE_RESET,
});

/**
 * Invitation Event 트랜스액션 요청 함수.
 *
 * @param {number} invNo 친구 추천 이벤트 번호
 * @param {number} tokenType
 * @param {string} transactionHash 트랜스액션해시값
 * @param callback
 * @param error
 */
export const invitationEventDepositRequest = ({
  invNo,
  tokenType,
  transactionHash,
  callback,
  error,
}) => ({
  type: types.INVITATION_EVENT_DEPOSIT_REQUEST,
  invNo,
  tokenType,
  transactionHash,
  callback,
  error,
});

/**
 * Invitation Event 예산 추가 트랜스 액션 요청 함수.
 *
 * @param {number} invNo 친구 추천 이벤트 번호
 * @param {number} addXper 추가 할 예산
 * @param {number} addPer 추가 할 예산
 * @param {string} transactionHash 트랜스액션해시값
 * @param callback
 * @param error
 * */
export const invitationEventAddBudget = ({
  invNo,
  addXper,
  addPer,
  transactionHash,
  callback,
  error,
}) => ({
  type: types.INVITATION_EVENT_ADD_BUDGET,
  invNo,
  addXper,
  addPer,
  transactionHash,
  callback,
  error,
});
